import React, {useState} from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import {Typography} from "@material-ui/core";

export default function EntryTypeDropDown({
                                              marketOrderEnabled, setMarketOrderEnabled,
                                              limitOrderEnabled, setLimitOrderEnabled,
                                              candleBreakEnabled, setCandleBreakEnabled,
                                              breakEnabled, setBreakEnabled
                                          }) {

    const values = [
        {type: "MARKET", setter: setMarketOrderEnabled},
        {type: "LIMIT", setter: setLimitOrderEnabled},
        {type: "CANDLE BREAK", setter: setCandleBreakEnabled},
        {type: "BREAK PRICE", setter: setBreakEnabled}
    ];
    let initialValue = "";
    if (marketOrderEnabled && !breakEnabled) {
        initialValue = "MARKET";
    } else if (limitOrderEnabled) {
        initialValue = "LIMIT";
    } else if (candleBreakEnabled) {
        initialValue = "CANDLE BREAK";
    } else if (breakEnabled) {
        initialValue = "BREAK PRICE";
    }
    return (<>
        <TextField
            select
            value={initialValue}
            variant="outlined"
            size="small"
            style={{backgroundColor: "white", width: "100%"}}
            onChange={ev => {
                for (let i in values) {
                    let value = values[i];
                    value.setter(value.type === ev.target.value);
                }
            }}
            label={<Typography style={{fontSize: 10}}>Entry Type</Typography>}
        >
            {values.map((option) => (
                <MenuItem key={option.type} value={option.type}>
                    <Typography style={{fontSize: 9}}>{option.type}</Typography>
                </MenuItem>
            ))}
        </TextField>
    </>);
}